import { Tag } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'translations/hooks';

export const YesNoTag = ({ value }: { value: boolean }) => {
  const { t } = useTranslation();

  const color = useMemo(() => {
    if (value) {
      return {
        text: '#2966FF',
        background: '#D5EAFF',
        border: '#C0DBF6',
      };
    } else {
      return {
        text: '#666666',
        background: '#EDEDED',
        border: '#D9D9D9',
      };
    }
  }, [value]);

  return (
    <Tag
      style={{
        color: color.text,
        borderColor: color.border,
        backgroundColor: color.background,
        borderRadius: 10,
      }}
    >
      <span>&#x25CF; </span>
      {t(`common.booleanValue.state`, {
        context: value ? 'true' : 'false',
      })}
    </Tag>
  );
};
